import { Link } from "react-router-dom";
import { CONTACT } from "../../data/publicSite";

const COLUMNS = [
  {
    heading: "Services",
    links: [
      { to: "/services/workplace-chaplaincy", label: "Workplace Chaplaincy" },
      { to: "/services/healthcare-hospice", label: "Healthcare" },
      { to: "/services/senior-living", label: "Senior Living / Board & Care" },
      { to: "/services/crisis-grief-bereavement", label: "Crisis, Grief & Bereavement" },
    ],
    subsections: [
      {
        heading: "Industries We Serve",
        links: [
          { to: "/industries/automotive-dealerships", label: "Automotive & Dealerships" },
          { to: "/industries/restaurants-hospitality", label: "Restaurants, Fast-Food Franchises & Hospitality" },
          { to: "/industries/construction-skilled-trades", label: "Construction & Skilled Trades" },
          { to: "/industries/real-estate-brokerages-title-services", label: "Real Estate, Brokerages & Title Services" },
        ],
      },
    ],
  },
  {
    heading: "Books & Resources",
    links: [
      { to: "/books", label: "Overview" },
      { to: "/books/from-diagnosis-to-goodbye", label: "From Diagnosis to Goodbye" },
      { to: "/books#workbooks", label: "Guided Workbooks" },
      { to: "/books#organizations", label: "Bulk / Organizational Orders" },
      { to: "/faq", label: "FAQs" },
    ],
  },
  {
    heading: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/for-organizations", label: "For Organizations" },
      { to: "/careers", label: "Careers" },
      { to: "/academy", label: "Chaplain Training Academy" },
      { to: "/contact", label: "Contact" },
      { to: "/care-portal", label: "Care Portal" },
      { to: "/callachap", label: "CALLACHAP" },
    ],
    subsections: [
      {
        heading: "For Organizations",
        links: [
          { to: "/services/leadership-employee-support", label: "Leadership / Employee Support" },
          { to: "/services/training-workshops", label: "Training & Workshops" },
        ],
      },
    ],
  },
];

export default function PublicFooter() {
  return (
    <footer className="bg-white border-t border-slate-200 mt-20" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src="/ccchaps-logo.png" alt="California Corporate Chaplains" className="h-9 w-9 object-contain" />
            <div className="leading-tight">
              <div className="font-heading font-semibold text-slate-900 text-sm">California Corporate Chaplains</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-slate-500 font-medium">CCCHAPS</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-slate-600 leading-relaxed">
            Confidential workplace chaplaincy for California's people-first organizations. Non-clinical, relationship-based support — scheduled on-site, remote, or blended — with 24/7 on-call chaplain access.
          </p>
          <p className="mt-4 text-xs text-slate-500 leading-relaxed" data-testid="footer-service-area">
            <span className="block">{CONTACT.serviceAreaOnsite}</span>
            <span className="block">{CONTACT.serviceAreaRemote}</span>
          </p>
          <p className="mt-4 text-sm">
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="footer-email"
              className="text-slate-700 hover:text-[#4A6FA5] font-medium"
            >
              {CONTACT.email}
            </a>
          </p>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.heading}>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-4">{col.heading}</p>
            <ul className="space-y-2.5 text-sm text-slate-600">
              {col.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="hover:text-slate-900">{l.label}</Link>
                </li>
              ))}
            </ul>

            {col.subsections?.map((sub) => (
              <div
                key={sub.heading}
                className="mt-6 pt-5 border-t border-slate-100"
                data-testid={`footer-subsection-${sub.heading.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                <p className="text-[11px] uppercase tracking-[0.2em] text-slate-500 font-semibold mb-3">
                  {sub.heading}
                </p>
                <ul className="space-y-2.5 text-sm text-slate-600">
                  {sub.links.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to} className="hover:text-slate-900">{l.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-500 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <span>© {new Date().getFullYear()} California Corporate Chaplains. All rights reserved.</span>
          <span>Confidential by design.</span>
        </div>
      </div>
    </footer>
  );
}
